import { render } from "./HowWorks.vue?vue&type=template&id=8bdabad4"
const script = {}

import exportComponent from "C:\\ProjectsLaravel\\nft_imw_v2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/ts/frontend/components/HowWorks.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8bdabad4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8bdabad4', __exports__)) {
    console.log('reload')
    api.reload('8bdabad4', __exports__)
  }
  
  module.hot.accept("./HowWorks.vue?vue&type=template&id=8bdabad4", () => {
    console.log('re-render')
    api.rerender('8bdabad4', render)
  })

}


export default __exports__